<app-header [headerStep]="headerStep" [local]="true"></app-header>
<div class="container mx-auto mb-6">
  <app-question [question]="question" [local]="true"></app-question>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div formArrayName="colocataires" class="my-4">
      <p-accordion [activeIndex]="0">
        <p-accordionTab
          *ngFor="let colocataire of colocataires.controls; let i = index"
          [iconPos]="'end'"
          [formGroupName]="i"
          [header]="'Colocataire N°' + (i + 1)">
          <div class="space-y-4">
            <!-- civilité / nom -->
            <div class="grid md:grid-cols-2 grid-cols-1 gap-x-4">
              <div>
                <span class="p-float-label">
                  <p-dropdown
                    formControlName="civilite"
                    class="width-max"
                    [options]="civilities"
                    optionLabel="text"
                    [placeholder]="resource.form.civility"></p-dropdown>
                  <label for="float-input" class="dropdown">{{ resource.form.civility }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('civilite')?.touched &&
                    colocataire.get('civilite')?.invalid &&
                    (colocataire.get('civilite')?.errors)!['required']
                  "
                  >{{ resource.error.civility }}</small
                >
              </div>
              <div>
                <span class="p-float-label">
                  <input type="text" pInputText formControlName="nom" />
                  <label for="float-input" class="inputtext">{{ resource.form.lastName }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('nom')?.touched &&
                    colocataire.get('nom')?.invalid &&
                    (colocataire.get('nom')?.errors)!['required']
                  "
                  >{{ resource.error.lastName }}</small
                >
              </div>
            </div>
            <!-- prénom / date naissance-->
            <div class="grid md:grid-cols-2 grid-cols-1 gap-x-4">
              <div>
                <span class="p-float-label">
                  <input type="text" pInputText formControlName="prenom" />
                  <label for="float-input" class="inputtext">{{ resource.form.firstName }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('prenom')?.touched &&
                    colocataire.get('prenom')?.invalid &&
                    (colocataire.get('prenom')?.errors)!['required']
                  "
                  >{{ resource.error.firstName }}</small
                >
              </div>

              <div>
                <span class="p-float-label">
                  <p-calendar
                    [touchUI]="true"
                    class="w-screen"
                    formControlName="dateNaissance"
                    dataType="string"
                    dateFormat="dd/mm/yy"
                    [defaultDate]="maxDate"
                    [maxDate]="maxDate"></p-calendar>
                  <label for="float-input" class="dropdown">{{ resource.form.birthday }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('dateNaissance')?.touched &&
                    colocataire.get('dateNaissance')?.invalid &&
                    (colocataire.get('dateNaissance')?.errors)!['required']
                  "
                  >{{ resource.error.birthday }}</small
                >
              </div>
            </div>

            <!-- pays naissance / nationalité -->
            <div class="grid md:grid-cols-2 grid-cols-1 gap-x-4">
              <div>
                <span class="p-float-label">
                  <p-autoComplete
                    class="w-full grid"
                    (completeMethod)="filterCountries($event)"
                    formControlName="paysNaissance"
                    [forceSelection]="true"
                    [suggestions]="filteredCountries"
                    [dropdown]="true"
                    [placeholder]="resource.form.birthdayCountry"
                    field="countryNameFr"
                    [minLength]="3"></p-autoComplete>
                  <label for="float-input" class="dropdown">{{
                    resource.form.birhdayCountry
                  }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('paysNaissance')?.touched &&
                    colocataire.get('paysNaissance')?.invalid &&
                    (colocataire.get('paysNaissance')?.errors)!['required']
                  "
                  >{{ resource.error.birthdayCountry }}</small
                >
              </div>
              <div>
                <span class="p-float-label">
                  <p-autoComplete
                    class="w-full grid"
                    (completeMethod)="filterCountries($event)"
                    formControlName="nationalite"
                    [forceSelection]="true"
                    [suggestions]="filteredCountries"
                    [dropdown]="true"
                    [placeholder]="resource.form.nationality"
                    field="countryNameFr"
                    [minLength]="3"></p-autoComplete>
                  <label for="float-input" class="dropdown">{{ resource.form.nationality }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('nationalite')?.touched &&
                    colocataire.get('nationalite')?.invalid &&
                    (colocataire.get('nationalite')?.errors)!['required']
                  "
                  >{{ resource.error.nationality }}</small
                >
              </div>
            </div>

            <!-- code postal naissance / ville naissance -->
            <div class="grid md:grid-cols-2 grid-cols-1 gap-x-4">
              <div>
                <span class="p-float-label">
                  <input type="text" pInputText formControlName="codePostalNaissance" />
                  <label for="float-input" class="inputtext">{{
                    resource.form.birthdayPostalCode
                  }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('codePostalNaissance')?.touched &&
                    colocataire.get('codePostalNaissance')?.invalid &&
                    (colocataire.get('codePostalNaissance')?.errors)!['required']
                  "
                  >{{ resource.error.postalCode }}</small
                >
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('codePostalNaissance')?.touched &&
                    colocataire.get('codePostalNaissance')?.invalid &&
                    (colocataire.get('codePostalNaissance')?.errors)!['pattern']
                  "
                  >{{ resource.error.postalCodeWrong }}</small
                >
              </div>
              <div>
                <span class="p-float-label">
                  <p-autoComplete
                    class="w-full grid"
                    formControlName="villeNaissance"
                    [dropdown]="true"
                    [suggestions]="filteredCity"
                    (completeMethod)="filterCity($event)"
                    [placeholder]="resource.form.city"
                    optionLabel="nomCommune"
                    optionValue="nomCommune" />
                  <label for="float-input" class="dropdown">{{
                    resource.form.birthdayPlace
                  }}</label>
                </span>
                <small
                  class="p-error"
                  *ngIf="
                    colocataire.get('villeNaissance')?.touched &&
                    colocataire.get('villeNaissance')?.invalid &&
                    (colocataire.get('villeNaissance')?.errors)!['required']
                  "
                  >{{ resource.error.city }}</small
                >
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
    <button
      pButton
      [disabled]="!this.form.valid"
      class="mx-auto button-NS width-max iconSideLabel"
      label="Valider"
      icon="pi pi-arrow-right"
      iconPos="right"
      type="submit"></button>
  </form>
</div>

<div class="container mx-auto h-28 md:h-40">
  <app-footer class="footer"></app-footer>
</div>
<app-web-callback></app-web-callback>
